<template>
	<GlobalSearchField
		ref="searchField"
		:placeholder="vm.CurrentBlock.SearchBarPlaceholder"
		:autofocus="false"
		:flag="flag"
		@search="executeFacetSearch"
	>
	</GlobalSearchField>
</template>

<script>
	import GlobalSearchField from 'shared/components/globalSearch/globalSearchField.vue'
	import globalSearchAutosuggestResultsMixin from 'shared/mixins/globalSearchAutosuggestResultsMixin.js';

	export default {
		name: 'GlobalSearchFieldWrapper',
		components: { GlobalSearchField },
		mixins: [globalSearchAutosuggestResultsMixin],
		props: {
			vm: {
				type: Object,
				default: () => {},
			},
			flag: {
				type: String,
				default: 'heroBA',
			}
		},
		methods: {
			executeFacetSearch() {
				this.executeSearch(this.vm.CurrentBlock.BusinessAreaPresetFilter);
			}
		}
	}
</script>
